import React from 'react'
import { useDispatch } from 'react-redux'
import { Box, Flex, Text } from '@pancakeswap/uikit'
import { AppDispatch } from 'state'
import { isTransactionRecent, useAllTransactions } from 'state/transactions/hooks'
import { useTranslation } from 'contexts/Localization'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { clearAllTransactions } from 'state/transactions/actions'
import { orderBy } from 'lodash'
import TransactionRow from './TransactionRow'
import styled from 'styled-components'
import useTheme from 'hooks/useTheme'

const ClearButton = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  color: ${({ theme }) => theme.colors.text};
  border-radius: 5px;
  font-size: 14px;
  padding: 5px 10px;
  transition: 0.3s;
  cursor: pointer;
  :hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

const WalletTransactions: React.FC = () => {
  const { chainId } = useActiveWeb3React()
  const dispatch = useDispatch<AppDispatch>()
  const { t } = useTranslation()
  const { theme } = useTheme()
  const allTransactions = useAllTransactions()
  const sortedTransactions = orderBy(Object.values(allTransactions).filter(isTransactionRecent), 'addedTime', 'desc')

  const handleClearAll = () => {
    if (chainId) {
      dispatch(clearAllTransactions({ chainId }))
    }
  }

  return (
    <Box minHeight="120px">
      <Flex alignItems="center" justifyContent="space-between" mb="10px" mt="24px">
        <Text color="text" fontSize="18px">
          {t('Recent Transactions')}
        </Text>
        {sortedTransactions.length > 0 && <ClearButton onClick={handleClearAll}>{t('Clear all')}</ClearButton>}
      </Flex>
      {sortedTransactions.length > 0 ? (
        sortedTransactions.map((txn) => <TransactionRow key={txn.hash} txn={txn} />)
      ) : (
        <Text textAlign="center" fontSize="14px" color={theme.colors.textSubtle}>
          {t('No recent transactions')}
        </Text>
      )}
    </Box>
  )
}

export default WalletTransactions
